import { Stack, Typography } from '@mui/material';
import React from 'react';
import ButtonWithLoading from 'src/components/common/ButtonWithLoading';
import ModalComponent from 'src/components/Modal/ModalComponent';
import { useNotification } from 'src/hooks/useNotification';

// Utilities
import { useMutateCancelSubscription } from 'src/services/mutate';

interface IProps {
  open: boolean;
  subscriptionId: string;
  handleClose: () => void;
  refetchUsage: () => void;
}

const PopupCancelPlan: React.FC<IProps> = ({ open, subscriptionId, handleClose, refetchUsage }) => {
  const { notification } = useNotification();
  const { mutateAsync, isPending } = useMutateCancelSubscription();

  const cancelSubscription = async () => {
    const response = await mutateAsync(subscriptionId);
    notification(
      response,
      {
        title: 'Cancel subscription',
        description: 'Cancel subscription successfully',
      },
      {
        title: 'Cancel subscription',
        description: 'Cancel subscription unsuccessfully',
      },
    );
    refetchUsage();
    handleClose();
  };

  return (
    <ModalComponent closeOnBackdropClick={false} showCloseIcon={true} padding={4} open={open} handleClose={handleClose}>
      <Stack direction="column" spacing={3}>
        <Stack direction="column" spacing={1} width={400} alignItems="center">
          <Typography textAlign="center" variant="h6">
            Are You Sure You Want to Cancel?
          </Typography>
          <Typography textAlign="center" variant="body1">
            Cancelling your subscription will result in the forfeiture of all unused credits. Once cancelled, your
            subscription cannot be reinstated. If you're unsure about cancelling, we encourage you to consider
          </Typography>
        </Stack>
        <Stack direction="row" spacing={2}>
          <ButtonWithLoading variant="outlined" color="primary" onClick={handleClose} disabled={isPending} fullWidth>
            Let me think
          </ButtonWithLoading>
          <ButtonWithLoading
            variant="contained"
            color="error"
            onClick={cancelSubscription}
            isLoading={isPending}
            disabled={isPending}
            fullWidth
          >
            yes, cancel my plan
          </ButtonWithLoading>
        </Stack>
      </Stack>
    </ModalComponent>
  );
};

export default PopupCancelPlan;
